import React from 'react';
import { Col, Colors, Image, Row, Text } from 'src/common';
import { RadioButton } from 'src/components';
import { DeliveryOptions } from 'src/features/common/types/application/delivery-options';

interface Props {
  address: string;
  label: string;
  disabledDelivery: boolean;
  onAssignDevice: () => void;
  highlighted: boolean;
  isDefaultAddress: boolean;
  deliveryOptions: DeliveryOptions[];
  onChange: (value: boolean) => void;
  deliveryOption?: string;
  productDetails: {
    devices: string;
    image: string;
    quantity: number;
  };
}

export const AssignDeviceItem = (props: Props) => {
  const [checked, setOnChecked] = React.useState(false);

  React.useEffect(() => {
    setOnChecked(props.deliveryOption !== DeliveryOptions.Stock);
    if (props.deliveryOptions.length > 1) {
      setOnChecked(props.deliveryOption !== DeliveryOptions.Stock);
    }
  }, [props.deliveryOption]);

  React.useEffect(() => {
    if (
      props.deliveryOptions.length === 1 &&
      props.deliveryOptions.includes(DeliveryOptions.Deliver)
    ) {
      setOnChecked(true);
    }
  }, []);

  React.useEffect(() => {
    if (props.deliveryOption === DeliveryOptions.Deliver && !checked) {
      setOnChecked(true);
    }
  }, [checked]);

  return (
    <Row
      alignItems={'center'}
      padding={'0 13px'}
      flex={1}
      margin={'0 0 5px 0'}
      gap={'12px'}
      backgroundColor={Colors.Grey50}
      className={props.highlighted ? 'highlight' : ''}
    >
      <Col
        css={`
          .input-style {
            margin-right: 0;
            width: 1.25rem;
            height: 1.25rem;
          }

          .centered {
            flex-direction: column;
            font-size: 0.875rem;
          }

          .label-style {
            color: ${Colors.Black} !important;
            margin-top: 0.25rem;
          }

          .selected {
            color: ${Colors.Black};
          }
        `}
      >
        <RadioButton
          automationId={'id-y'}
          label={props.label}
          light={true}
          disabled={props.disabledDelivery}
          onChange={() => {
            props.onChange(!checked);
            setOnChecked(!checked);
          }}
          value={'Deliver'}
          field={{
            checked: checked,
            type: 'checkbox',
            name: 'delivery',
          }}
        />
      </Col>
      <Row width="50%" margin={'15px 0'} alignItems={'center'} flex={1} gap={'8px'}>
        <Col
          justifyContent={'center'}
          alignItems={'center'}
          width={'40px'}
          height={'40px'}
          border={'1px solid rgba(0, 0, 0, 0.2)'}
          borderRadius={'5px'}
          backgroundColor={Colors.White}
        >
          <Image
            width={'18px'}
            height={'30px'}
            src={props.productDetails.image}
            alt={props.productDetails.devices}
          />
        </Col>
        <Col width="82%">
          <Row display="flex" gap={'10px'} fontSize={'16px'}>
            <Text
              as={'p'}
              lineHeight={'21px'}
              fontWeight={400}
              fontSize={'14px'}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              whiteSpace={'nowrap'}
            >
              {props.address}
            </Text>
            {checked && !props.isDefaultAddress && (
              <>
                |{' '}
                <Text
                  cursor={'pointer'}
                  as={'p'}
                  color={Colors.Red}
                  onClick={props.onAssignDevice}
                  textDecoration={'underline'}
                >
                  Edit
                </Text>
              </>
            )}
          </Row>

          {checked && (
            <Text as={'p'} lineHeight={'18px'} fontWeight={400} fontSize={'12px'}>
              {`${props.productDetails.quantity}x ${props.productDetails.devices}`}
            </Text>
          )}
          {!checked && (
            <Text
              width="fit-content"
              color={Colors.White}
              fontSize={'12px'}
              borderRadius={'16px'}
              padding="1px 5px"
              as={'p'}
              backgroundColor={Colors.LightTeal}
            >
              Collect now
            </Text>
          )}
        </Col>
      </Row>
    </Row>
  );
};
